const BoxList = () => import('Views/box/box-list');
const BoxAddEdit = () => import('Views/box/box-addEdit');
const BoxDetail = () => import('Views/box/box-detail');

export default[
  { path: '/box-list', component: BoxList },
  { path: '/box-add', component: BoxAddEdit },
  { path: '/box-edit/:id', component: BoxAddEdit },
  { path: '/box-detail/:id', component: BoxDetail },
];



// WEBPACK FOOTER //
// ./src/router/box.js